import {isNil} from 'ramda';

import {type SaleBusinessCasePricesOverviewResponseBody} from '@dms/api/sales';
import {type usePricePermissions} from '@dms/shared';

import {type Nullish} from 'shared/web';

type PricePermissions = ReturnType<typeof usePricePermissions>;

/**
 * Which sale prices of a selling business case the user may read, and which withheld ones read
 * as not available.
 */
export const getSalePriceVisibility = (
  permissions: PricePermissions,
  prices: SaleBusinessCasePricesOverviewResponseBody | Nullish
) => {
  const canReadSellingPrice =
    permissions.canReadVehicleSellingPrice && permissions.canReadBusinessCaseSaleVehicleSalePrice;
  const canReadSaleMargins =
    permissions.canReadVehicleCosts &&
    permissions.canReadVehicleEarnings &&
    permissions.canReadBusinessCaseSaleProfit &&
    canReadSellingPrice &&
    permissions.canReadBusinessCaseSaleVehiclePurchasePrice &&
    permissions.canReadVehiclePurchasePrice &&
    permissions.canReadBusinessCaseBrokerageFees;
  const canReadExpectedEarnings =
    permissions.canReadVehicleEarnings &&
    permissions.canReadBusinessCaseSaleProfit &&
    permissions.canReadBusinessCaseSaleVehiclePurchasePrice;

  return {
    canReadSellingPrice,
    canReadSaleMargins,
    canReadExpectedEarnings,
    isUpsellNotAvailable: !canReadSellingPrice && isNil(prices?.upsell),
    isDiscountNotAvailable: !canReadSellingPrice && isNil(prices?.discount),
    isRealCostsNotAvailable:
      !(
        permissions.canReadVehicleCosts && permissions.canReadBusinessCaseSaleVehiclePurchasePrice
      ) && isNil(prices?.realCosts),
  };
};
